/***
 *                    _ooOoo_
 *                   o8888888o
 *                   88" . "88
 *                   (| -_- |)
 *                    O\ = /O
 *                ____/`---'\____
 *              .   ' \\| |// `.
 *               / \\||| : |||// \
 *             / _||||| -:- |||||- \
 *               | | \\\ - /// | |
 *             | \_| ''\---/'' | |
 *              \ .-\__ `-` ___/-. /
 *           ___`. .' /--.--\ `. . __
 *        ."" '< `.___\_<|>_/___.' >'"".
 *       | | : `- \`.;`\ _ /`;.`/ - ` : | |
 *         \ \ `-. \_ __\ /__ _/ .-` / /
 * ======`-.____`-.___\_____/___.-`____.-'======
 *                    `=---='
 *
 * .............................................
 *          佛祖保佑             永无BUG
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import busPlugin from './utils/bus'
import './permission'
import './plugins/components'
import './icons'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import './style/index.less'
import './bind-enum'
import './filters'
import VueCompositionApi from '@vue/composition-api'
import './vee-validate'
import './tailwind/index.css'

Vue.use(VueCompositionApi)
Vue.use(busPlugin)
Vue.use(Antd)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
